import { defineMessages, MessageDescriptor } from 'react-intl';

export const filterScopes = (scopes: string[]) =>
  scopes.filter((scope) => !ignoredScopes.has(scope));

export const ignoredScopes = new Set(['offline_access']);

export const scopeDescriptions: Record<string, MessageDescriptor> =
  defineMessages({
    'read:board:trello': {
      id: 'oauth.scopes.read-board-trello',
      defaultMessage: 'Read your boards',
      description:
        'Scope description for read:board:trello - reading board data',
    },
    'read:enterprise:trello': {
      id: 'oauth.scopes.read-enterprise-trello',
      defaultMessage: 'Read your enterprises',
      description:
        'Scope description for read:enterprise:trello - reading enterprise data',
    },
    'read:member:trello': {
      id: 'oauth.scopes.read-member-trello',
      defaultMessage:
        'Read your email address, public name, public avatar, and memberships of boards, workspaces, and enterprises',
      description:
        'Scope description for read:member:trello - reading member profile and membership data',
    },
    'read:organization:trello': {
      id: 'oauth.scopes.read-organization-trello',
      defaultMessage: 'Read your workspaces and power-ups you own',
      description:
        'Scope description for read:organization:trello - reading workspace and power-up data',
    },
    'write:board:trello': {
      id: 'oauth.scopes.write-board-trello',
      defaultMessage:
        'Create and update all cards and lists, and add comments in your boards',
      description:
        'Scope description for write:board:trello - creating and updating board content including cards, lists, and comments',
    },
    'write:board:membership:trello': {
      id: 'oauth.scopes.write-board-membership-trello',
      defaultMessage: 'Add, remove, or modify memberships on your boards',
      description:
        'Scope description for write:board:membership:trello - adding and updating board memberships',
    },
    'write:enterprise:trello': {
      id: 'oauth.scopes.write-enterprise-trello',
      defaultMessage: 'Update and manage your enterprises',
      description:
        'Scope description for write:enterprise:trello - updating and managing enterprise settings',
    },
    'write:member:trello': {
      id: 'oauth.scopes.write-member-trello',
      defaultMessage:
        'Add you to boards and workspaces, and upload custom assets on your behalf',
      description:
        'Scope description for write:member:trello - updating member settings and joining boards/organizations',
    },
    'write:organization:trello': {
      id: 'oauth.scopes.write-organization-trello',
      defaultMessage: 'Update your workspaces',
      description:
        'Scope description for write:organization:trello - updating workspace settings and creating workspaces',
    },
    'write:organization:membership:trello': {
      id: 'oauth.scopes.write-organization-membership-trello',
      defaultMessage: 'Add, remove, or modify memberships on your workspaces',
      description:
        'Scope description for write:organization:membership:trello - add and update workspace memberships',
    },
    'read:member.inbox:trello': {
      id: 'oauth.scopes.read-member-inbox-trello',
      defaultMessage: 'Read your inbox',
      description:
        "Scope description for read:member.inbox:trello - reading the user's inbox",
    },
    'write:member.inbox:trello': {
      id: 'oauth.scopes.write-member-inbox-trello',
      defaultMessage: 'Write to your inbox',
      description:
        "Scope description for write:member.inbox:trello - writing to the user's inbox",
    },
    'read:member.planner:trello': {
      id: 'oauth.scopes.read-member-planner-trello',
      defaultMessage: 'Read your planner',
      description:
        "Scope description for read:member.planner:trello - reading the user's planner",
    },
    'write:member.planner:trello': {
      id: 'oauth.scopes.write-member-planner-trello',
      defaultMessage: 'Write to your planner',
      description:
        "Scope description for write:member.planner:trello - writing to the user's planner",
    },
  });
